import { boolean, object, ObjectSchema, string } from 'yup';
import { COMMON_TRANSLATION } from '@/common/constants';
import { DATE_FORMAT_VALIDATION_REGEX } from '@/common/utils';
import { TFunction } from 'i18next';

export const createWithdrawalSchema = ({
  t,
  participantFirstName,
  participantLastName,
  participantEmail,
  hrnSampleStatusOptions,
  typeOfRequestOptions,
  paperConsentOptions,
}: {
  t: TFunction;
  participantFirstName: any;
  participantLastName: any;
  participantEmail: any;
  hrnSampleStatusOptions: any;
  typeOfRequestOptions: any;
  paperConsentOptions: any;
}): ObjectSchema<any> =>
  object({
    participantDateOfBirth: string()
      .required(
        t('form.errors.required', {
          ns: COMMON_TRANSLATION,
          label: t('form.research_participant_s.research_participant_s_date_of_birth'),
        }),
      )
      .trim()
      .matches(DATE_FORMAT_VALIDATION_REGEX, t('form.errors.date_of_birth')),
    participantMRN: string()
      .required(
        t('form.errors.required', {
          ns: COMMON_TRANSLATION,
          label: t('form.research_participant_s.research_participant_s_mrn'),
        }),
      )
      .max(
        50,
        t('form.errors.max_length', {
          ns: COMMON_TRANSLATION,
          label: t('form.research_participant_s.research_participant_s_mrn'),
          max: 50,
        }),
      ),
    participantFirstName,
    participantLastName,
    participantEmail,
    typeOfRequest: string()
      .required(
        t('form.errors.required', {
          ns: COMMON_TRANSLATION,
          label: t('form.request_details.type_of_request'),
        }),
      )
      .oneOf(typeOfRequestOptions.map((typeOfRequest: any) => typeOfRequest.id)),
    hrnSampleStatus: string()
      .required(
        t('form.errors.required', {
          ns: COMMON_TRANSLATION,
          label: t('form.request_details.hrn_sample_status'),
        }),
      )
      .oneOf(hrnSampleStatusOptions.map((hrnSampleStatus: any) => hrnSampleStatus.id)),
    consentMethod: string()
      .required(
        t('form.errors.required', {
          ns: COMMON_TRANSLATION,
          label: t('form.request_details.paper_consent_title'),
        }),
      )
      .oneOf(paperConsentOptions.map((consentMethod: any) => consentMethod.id)),
    documentationConfirmation: boolean()
      .required(
        t('form.errors.required', {
          ns: COMMON_TRANSLATION,
          label: t('form.documentation_check'),
        }),
      )
      .oneOf(
        [true],
        t('form.errors.required', {
          ns: COMMON_TRANSLATION,
          label: t('form.documentation_check'),
        }),
      ),
    orderCancellationCheck: boolean()
      .required(
        t('form.errors.required', {
          ns: COMMON_TRANSLATION,
          label: t('form.order_cancellation_check'),
        }),
      )
      .oneOf(
        [true],
        t('form.errors.required', {
          ns: COMMON_TRANSLATION,
          label: t('form.order_cancellation_check'),
        }),
      ),
  });
